import {
  Children,
  cloneElement,
  isValidElement,
  useLayoutEffect,
  useRef,
} from 'react';
import { useIsFetching } from '@tanstack/react-query';

import './data-panel.css';

function injectMap(element, map, navigate) {
  if (!isValidElement(element)) return element;

  const children = element.props.children;
  const injectedChildren = Children.map(children, child => injectMap(child, map, navigate));
  const props = typeof element.type === 'string' ? {} : { map, navigate };

  if (children !== undefined) {
    props.children = injectedChildren;
  }

  return cloneElement(element, props);
}

function DataPanel({ outlet, map, navigate, onContentChange }) {
  const content = injectMap(outlet, map, navigate);
  const panelRef = useRef(null);
  const isFetching = useIsFetching({
    predicate: query => query.queryKey[0] !== 'delta-t',
  }) > 0;

  useLayoutEffect(() => {
    onContentChange(panelRef.current?.hasChildNodes() ?? false);
  }, [content, onContentChange]);

  return (
    <div
      ref={panelRef}
      className="data-panel"
      aria-busy={isFetching}
    >
      {isFetching && (
        <div className="data-panel__loader" role="status" aria-label="Laden">
          <span className="data-panel__loader__spinner" />
        </div>
      )}
      {content}
    </div>
  );
}

export default DataPanel;
